import {getNewOutlet} from 'reconnect.js';
import {buildCatDisplayMap} from '../Utils/buildCatDisplayMap';
import './featureOptions';
import config from '../../data.json';

const customPuzzleData =
  config.stage === 'stg'
    ? [
        {
          productId: '612c4f2dea067ac5491c62c6',
          maskImg: '/images/custom-puzzle-assets/materials/40x40-materials.png',
          separateLineImg:
            '/images/custom-puzzle-assets/separate-lines/40x40-sl.png',
          aspect: 1545 / 1083,
          size: {w: 1545, h: 1083}, // px with bleed
        },
        {
          productId: '616cec429389cb7c08f2d85a',
          maskImg: '/images/custom-puzzle-assets/materials/80x80-materials.png',
          separateLineImg:
            '/images/custom-puzzle-assets/separate-lines/80x80-sl.png',
          aspect: 1102 / 822,
          size: {w: 1102, h: 822},
        },
        {
          productId: '616cec6d9389cb7c08f2d85b',
          maskImg:
            '/images/custom-puzzle-assets/materials/120x120-materials.png',
          separateLineImg:
            '/images/custom-puzzle-assets/separate-lines/120x120-sl.png',
          aspect: 1526 / 1078,
          size: {w: 1526, h: 1078},
        },
        {
          productId: '616cec989389cb7c08f2d85c',
          maskImg:
            '/images/custom-puzzle-assets/materials/200x200-materials.png',
          separateLineImg:
            '/images/custom-puzzle-assets/separate-lines/200x200-sl.png',
          aspect: 1993 / 1388,
          size: {w: 1993, h: 1388},
        },
        {
          productId: '616cecb79389cb7c08f2d85d',
          maskImg:
            '/images/custom-puzzle-assets/materials/300x300-materials.png',
          separateLineImg:
            '/images/custom-puzzle-assets/separate-lines/300x300-sl.png',
          aspect: 1978 / 1383,
          size: {w: 1978, h: 1383},
        },
      ]
    : [
        {
          productId: '616cd6a654322c581d79ef2a',
          maskImg: '/images/custom-puzzle-assets/materials/40x40-materials.png',
          separateLineImg:
            '/images/custom-puzzle-assets/separate-lines/40x40-sl.png',
          aspect: 1545 / 1083,
          size: {w: 1545, h: 1083}, // px with bleed
        },
        {
          productId: '616cd69954322c581d79ef29',
          maskImg: '/images/custom-puzzle-assets/materials/80x80-materials.png',
          separateLineImg:
            '/images/custom-puzzle-assets/separate-lines/80x80-sl.png',
          aspect: 1102 / 822,
          size: {w: 1102, h: 822},
        },
        {
          productId: '616cd68754322c581d79ef28',
          maskImg:
            '/images/custom-puzzle-assets/materials/120x120-materials.png',
          separateLineImg:
            '/images/custom-puzzle-assets/separate-lines/120x120-sl.png',
          aspect: 1526 / 1078,
          size: {w: 1526, h: 1078},
        },
        {
          productId: '616cd412364f2a54485e6723',
          maskImg:
            '/images/custom-puzzle-assets/materials/200x200-materials.png',
          separateLineImg:
            '/images/custom-puzzle-assets/separate-lines/200x200-sl.png',
          aspect: 1993 / 1388,
          size: {w: 1993, h: 1388},
        },
        {
          productId: '616cd3f2364f2a54485e6722',
          maskImg:
            '/images/custom-puzzle-assets/materials/300x300-materials.png',
          separateLineImg:
            '/images/custom-puzzle-assets/separate-lines/300x300-sl.png',
          aspect: 1978 / 1383,
          size: {w: 1978, h: 1383},
        },
      ];

// configurations for "product" collection
const sortOptions = [
  {name: '-created', display: '上架時間(由新到舊)'},
  {name: 'price', display: '價格(由低到高)'},
  {name: 'created', display: '上架時間(由舊到新)'},
];

const categories = [
  {
    name: 'all',
    display: '所有分類',
    items: [],
  },
];

// configurations for "Article_Default" collection
const articleSortOptions = [
  {name: '-created', display: '發布時間(由新到舊)'},
  {name: 'created', display: '發布時間(由舊到新)'},
];

const articleCategories = [
  {
    name: 'A',
    display: 'Doc A',
  },
  {
    name: 'B',
    display: 'Doc B',
  },
  {
    name: 'C',
    display: 'Doc C',
    items: [
      {name: 'C-a', display: 'Doc C-a'},
      {name: 'C-b', display: 'Doc C-b'},
      {name: 'C-c', display: 'Doc C-c'},
    ],
  },
];

getNewOutlet('user', null, {autoDelete: false});
getNewOutlet('loading', false, {autoDelete: false});
getNewOutlet('login-modal', false, {autoDelete: false});
getNewOutlet('contact-modal', false, {autoDelete: false});
getNewOutlet('reset-password-modal', false, {autoDelete: false});

getNewOutlet('landing', {}, {autoDelete: false});

// product collection
getNewOutlet('categories', categories, {autoDelete: false});
getNewOutlet('categoryDisplayMap', buildCatDisplayMap(categories), {
  autoDelete: false,
});
getNewOutlet('sortOptions', sortOptions, {autoDelete: false});
getNewOutlet('customPuzzleData', customPuzzleData, {autoDelete: false});

// Article_Default collection
getNewOutlet('articleCategories', articleCategories, {autoDelete: false});
getNewOutlet(
  'articleCategoryDisplayMap',
  buildCatDisplayMap(articleCategories),
  {
    autoDelete: false,
  },
);
getNewOutlet('articleSortOptions', articleSortOptions, {autoDelete: false});

getNewOutlet(
  'cart',
  {
    items: [],
    extra_items: [],
    discount_items: [],
  },
  {autoDelete: false},
);
getNewOutlet('dimension', {rwd: 'mobile'}, {autoDelete: false});
getNewOutlet('actions', null, {autoDelete: false});
getNewOutlet('ApiUtil', {}, {autoDelete: false});
